import RelationContact from "./relation-contact.model";
import Model from "./model";

export class TicketMessage extends Model {
  datetime: string = '';
  description: string = '';
  relation_contact: RelationContact | null = null;
  sender: string = 'UNKNOWN';
}
